import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './faqs.css'; // We'll define custom styles here

const FAQs = () => {
  const faqs = [
  {
    question: 'Who is eligible to apply for a loan with Loanonsalary?',
    answer: 'Salaried individuals with a stable income, valid KYC documents, and a good credit history can apply for a loan.',
  },
  {
    question: 'What documents do I need to submit for a loan application?',
    answer: 'You will typically need your Aadhaar card, PAN card, recent salary slips, and bank statements.',
  },
  {
    question: 'How long does it take to get loan approval?',
    answer: 'Loan approval usually takes a few minutes to a few hours once all documents are submitted correctly.',
  },
  {
    question: 'What is the maximum loan amount I can apply for?',
    answer: 'Loan amounts vary based on your income and credit profile, but we offer competitive limits tailored to your needs.',
  },
  {
    question: 'What interest rates does Loanonsalary offer?',
    answer: 'Our interest rates are competitive and depend on your profile; we ensure transparency with no hidden charges.',
  },
  {
    question: 'Can I repay my loan before the tenure ends?',
    answer: 'Yes, you can prepay your loan partially or fully without any penalty charges.',
  },
  {
    question: 'Is my personal data safe with Loanonsalary?',
    answer: 'Absolutely. We use secure encryption and comply with RBI guidelines to protect your data privacy.',
  },
  {
    question: 'How do I check the status of my loan application?',
    answer: 'You can track your application status anytime through our website or mobile app using your application ID.',
  },
  {
    question: 'What happens if I miss an EMI payment?',
    answer: 'Please contact our support team immediately; we offer flexible solutions and will help you manage the situation.',
  },
  {
    question: 'Does Loanonsalary provide customer support?',
    answer: 'Yes, our dedicated support team is available via phone, email, and chat to assist you throughout the loan process.',
  },
];


  return (
    <section className="faq-section py-3">
      <div className="container">
        <h2 style={{ color: '#052daa', textAlign: 'center', marginBottom: '2rem' }}>Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item border-0 mb-3 shadow-sm" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded={index === 0 ? 'true' : 'false'}
                  aria-controls={`collapse${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
